<template>
  <header v-if="!route.meta.hideLayout">
    <MainMenu />
    <BreadCrumbs />
  </header>
  <RouterView />
  <TheFooter v-if="!route.meta.hideLayout" />
</template>

<script setup>
import { RouterView, useRoute } from 'vue-router'
import MainMenu from '@/components/MainMenu.vue'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import TheFooter from '@/components/TheFooter.vue'

const route = useRoute()
</script>
